"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CustomLink;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

var _reactRouterDom = require("react-router-dom");

function CustomLink(_ref) {
  var linkTo = _ref.linkTo,
      linkIcon = _ref.linkIcon,
      title = _ref.title,
      _ref$useAnchor = _ref.useAnchor,
      useAnchor = _ref$useAnchor === void 0 ? false : _ref$useAnchor,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active; // since the placeListings url contains query params.
  // react router doesnt interpret query params.
  // link would not be active.

  linkTo = linkTo.includes('?') ? linkTo.split('?')[0] : linkTo;
  var AnchorOrLink = useAnchor ? 'a' : _reactRouterDom.NavLink;
  return _react["default"].createElement(_reactstrap.NavItem, null, _react["default"].createElement(AnchorOrLink, (0, _extends2["default"])({}, useAnchor ? {
    href: linkTo
  } : {
    to: linkTo
  }, {
    "aria-label": title,
    className: "nav-link ".concat(active ? 'active' : '')
  }), title && _react["default"].createElement("span", null, title), _react["default"].createElement("div", {
    className: "d-block d-lg-none mobile-icon"
  }, _react["default"].createElement("img", {
    src: "https://s3.amazonaws.com/honeyguide/assets/icons/".concat(linkIcon),
    alt: ""
  }), _react["default"].createElement("p", null, title))));
}